import { getStoreBuilder,BareActionContext } from "vuex-typex";
import { CartState, RootState } from "Store/types";
import { ICartSummary, ProductKeyQuantity, CartClient, OrderLineComment } from "Api/DynamicwebApi";
import ApiProvider from "Api/ApiProvider";

const initialCartState: CartState = {
    error: false,
    summary: undefined,
    isLoading: false
}
var loadPromise : Promise<any>;

const c = getStoreBuilder<RootState>().module("cart",initialCartState);


//Mutations
function cartUpdated(state:CartState,payload:ICartSummary){
    state.error = false;
    state.isLoading = false;
    state.summary = payload;
}
function cartError(state:CartState){
    state.error = true;
    state.isLoading = false;
    state.summary = undefined;
}
function cartLoading(state:CartState){
    state.isLoading = true;
}

//Actions
async function updateCart(context:BareActionContext<CartState,RootState>,data:ProductKeyQuantity){
    const client = ApiProvider.getDwApiClient();
    return client.updateCartQuantity(data)
        .then(res => {
            cart.commitCartUpdated(res);
        });
}

async function updateOrderline(context: BareActionContext<CartState, RootState>, data: OrderLineComment) {
    const client = ApiProvider.getDwApiOrderlineClient();
    return client.addOrderlineComment(data); 
}

async function fetchCart(context: BareActionContext<CartState, RootState>): Promise<ICartSummary> {
    if(loadPromise) return loadPromise;

    return loadPromise = new Promise((resolve, reject) => {
        cart.commitCartLoading();
        const client = ApiProvider.getDwApiClient();
        client.getCartSummary()
            .then(res => {
                cart.commitCartUpdated(res);
                resolve();
                loadPromise = null;
            })
            .catch(e => {
                cart.commitCartError();
                reject(e);
                loadPromise = null;
            });
    });
}

const stateGetter = c.state();

const cart = {
    //State
    get state() {return stateGetter()},

    //Getters

    //Mutations
    commitCartUpdated: c.commit(cartUpdated),
    commitCartError: c.commit(cartError),
    commitCartLoading: c.commit(cartLoading),
    //Actions
    dispatchUpdateCart: c.dispatch(updateCart),
    dispatchFetchCart: c.dispatch(fetchCart),
    dispatchUpdateOrderline: c.dispatch(updateOrderline),
}
export default cart;